// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VVeDe","title":"styles_title__13jVw"};